import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Stats } from '../models/Stats';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatsService {

  constructor(public http: HttpClient) { }

  public getStats(idSyncro: number){
    return this.http.get<Stats>(`${environment.urlBackend}stats?idSyncro=${idSyncro}`);
  }
}
